import BigDialog from 'components/BigDialog';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions as actionsRawMaterials } from 'ducks/rawMaterials';
import { actions as actionsRawMatSuppliers } from 'ducks/rawMaterialSuppliers';
import { actions as actionsSupplierRegister } from 'ducks/supplierRegister';
import Suppliers from 'pages/Inventory/Suppliers';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { directRegistersByShipment, groupBy, lookUpIdValueSelector, shipmentsByRawMaterial } from 'selectors/generic';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/inventory/shipment';
import { validator as shipmentRegisterValidator } from 'utils/tables/validators/shipmentRegistersMixtures';
import { validator as shipmentValidator } from 'utils/tables/validators/shipments';
import { currentUser } from 'selectors/currentUser';

const Component = props => {
    const {
        compositionByRawMaterial, directRegistersOfShipment, idAccount, fullSize,
        productsById, rawMaterial, shipmentId, shipmentsOfRawMaterial, suppliers
    } = props;
    const {
        alertError, closeParentContainer, createRawMatSupplier, createSupplierRegister,
        fetchRawMaterial, removeRawMatSupplier, removeSupplierRegister, rawMaterials,
        setParentLoading, setShipment, updateRawMatSupplier, updateSupplierRegister
    } = props;
    const tableRef = React.useRef(null);

    // `rawMaterial.raw_material_suppliers`, from the slice that holds them.
    const rawMaterialShipments = shipmentsOfRawMaterial[rawMaterial.id] || [];
    let shipments = rawMaterialShipments;

    const [boxSuppliers, setBoxSuppliers] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (rawMaterialShipments.length !== 0) {
            const firstShipment = rawMaterialShipments[0];
            setShipment(firstShipment.id);
        }
    }, []);

    const onToggleBoxSuppliers = () => setBoxSuppliers(!boxSuppliers);

    const initValuesForColumns = {};

    shipments = shipments.map(shipment => {
        //const registration = shipment.supplier_registers
        //  .find(register => register['raw_material_supplier_id'] && !register['mixture_id']);
        const directRegisters = directRegistersOfShipment[shipment.id] || [];
        const registration = directRegisters.length === 1 ?
            directRegisters[0] : initValuesForColumns;
        const supplier = shipment['supplier_id'];

        return {
            ...registration,
            ...shipment,
            supplier_id: supplier
        };
    });

    console.log('suppliers',suppliers);

    return (
        <React.Fragment>
            <BaseTable
                ref={tableRef}
                titleBack={true}
                titleAction={closeParentContainer}
                title={
                    `${rawMaterial.code} - 
          ${rawMaterial.name}
          ${rawMaterial.cas.length > 0 ? ` - [CAS] ${rawMaterial.cas}` : ''}
          ${rawMaterial.ec.length > 0 ? ` - [EC] ${rawMaterial.ec}` : ''}`
                }
                columns={columns(rawMaterial.type, suppliers)}
                data={shipments}
                isLoading={loading}
                paging={false}
                halfSize={!fullSize}
                options={{
                    rowStyle: rowData => ({
                        backgroundColor: rowData.id === shipmentId ?
                            theme.palette.primary.light : ''
                    })
                }}
                onRowClick={() => null}
                onRowDoubleClick={rowData => setShipment(rowData.id)}
                editable={{
                    onRowAdd: newData => {
                        const sValidation = shipmentValidator(newData, rawMaterials, shipmentsOfRawMaterial);
                        const srValidation = shipmentRegisterValidator(newData, undefined);
                        if (sValidation.error || srValidation.error) {
                            alertError([
                                ...sValidation.error ? sValidation.error : [],
                                ...srValidation.error ? srValidation.error : []
                            ]);
                            return Promise.reject();
                        }
                        setLoading(true);
                        setParentLoading(true);
                        const raw_material_id = rawMaterial.id;
                        const tempData = { ...newData, account_id: idAccount, raw_material_id };
                        return createRawMatSupplier(tempData)
                            .then((data) => {
                                const raw_material_supplier_id = data.id;
                                setShipment(raw_material_supplier_id);
                                const tempData = { ...newData, account_id: idAccount, raw_material_supplier_id };
                                return createSupplierRegister(tempData);
                            })
                            .then(() => fetchRawMaterial(rawMaterial.id))
                            .catch(e => alert(e))
                            .finally(() => {
                                setLoading(false);
                                setParentLoading(false);
                            });
                    },

                    onRowUpdate: (newData) => {
                        const sValidation = shipmentValidator(newData, rawMaterials, shipmentsOfRawMaterial);
                        const srValidation = shipmentRegisterValidator(newData, undefined);
                        if (sValidation.error || srValidation.error) {
                            alertError([
                                ...sValidation.error ? sValidation.error : [],
                                ...srValidation.error ? srValidation.error : []
                            ]);
                            return Promise.reject();
                        }
                        setLoading(true);
                        setParentLoading(true);
                        // The row is a shipment merged with its own registration,
                        // so `newData.id` is the shipment's; the registration to
                        // update comes from the index, not from the row.
                        const directRegisters = directRegistersOfShipment[newData.id] || [];
                        return updateRawMatSupplier(newData.id, { ...newData })
                            .then(() => {
                                if (directRegisters.length === 0) {
                                    const raw_material_supplier_id = newData.id;
                                    const tempData = { ...newData, account_id: idAccount, raw_material_supplier_id };
                                    return createSupplierRegister(tempData);
                                } else {
                                    updateSupplierRegister(directRegisters[0].id, { ...newData });
                                }
                            })
                            .then(() => fetchRawMaterial(rawMaterial.id))
                            .catch(e => alert(e))
                            .finally(() => {
                                setLoading(false);
                                setParentLoading(false);
                            });
                    },

                    onRowDelete: (oldData) => {
                        // TODO If PapelReach UJ cannot delete the last shipmentUJ if MP in a product
                        //      mp_formulação true or inter_substâncias de mix com mp_formulação true
                        // TODO If PapelReach Fabricante mp_formulação false && mixture_id === null

                        // TODO Should be corrected in API
                        // `rawMaterial.products` was the m2m through
                        // product_raw_materials, repeats included - which is
                        // what the Set was here to remove.
                        const productSet = new Set(
                            (compositionByRawMaterial[rawMaterial.id] || []).map(prm => prm.product_id));
                        const productIds = Array.from(productSet);

                        // switch (oldData.reach_role) {
                        //   case FABRICANTE:
                        //   case DISTRIBUIDOR:
                        //     const productRawMaterialswhereProducerDistributor = [];
                        //     productIds.forEach( productId =>
                        //       productsById[productId].product_raw_materials.forEach( prm => {
                        //         if (prm.raw_material_id.id === rawMaterial.id &&
                        //             !prm.added_to_charge && !prm.mixture_id) {
                        //           productRawMaterialswhereProducerDistributor.push(prm);
                        //         }
                        //       })
                        //     );
                        //
                        //     if (productRawMaterialswhereProducerDistributor.length > 0) {
                        //       const productList = productRawMaterialswhereProducerDistributor
                        //         .map(prm => prm.product_id.name).join(', ');
                        //       alertError(`Fornecimento não pode ser apagado, substância usada na
                        //         reacção dos seguintes produtos:  ${productList}`);
                        //       return Promise.resolve();
                        //     }
                        //
                        //     break;
                        //
                        //   case UJ:
                        //     const productRawMaterialswhereUJ = [];
                        //     productIds.forEach( productId =>
                        //       productsById[productId].product_raw_materials.forEach( prm => {
                        //         const mixturesWhereRawMaterial = rawMaterial.mixtures.map( mix => mix.mixture_id);
                        //         if (prm.raw_material_id.id === rawMaterial.id && prm.added_to_charge ||
                        //             mixturesWhereRawMaterial.includes(prm.raw_material_id.id)) {
                        //           productRawMaterialswhereUJ.push(prm);
                        //         }
                        //       })
                        //     );
                        //
                        //     if (productRawMaterialswhereUJ.length > 0) {
                        //       const productList = productRawMaterialswhereUJ
                        //         .map(prm => prm.product_id.name).join(', ');
                        //       alertError(`Fornecimento não pode ser apagado, substância usada na
                        //         carga dos seguintes produtos:  ${productList}`);
                        //       return Promise.resolve();
                        //     }
                        //     break;
                        // }

                        setLoading(true);
                        setParentLoading(true);
                        setShipment(undefined);
                        return removeRawMatSupplier(oldData.id)
                            .then(() => fetchRawMaterial(rawMaterial.id))
                            .catch(e => alert(e))
                            .finally(() => {
                                setLoading(false);
                                setParentLoading(false);
                            });
                    }
                }}
                actions={
                    [
                        {
                            isFreeAction: true,
                            icon: tableIcons.Supplier,
                            tooltip: 'Visualizar Fornecedores',
                            onClick: (event, rowData) => onToggleBoxSuppliers()
                        }
                    ]
                }
            />
            <BigDialog open={boxSuppliers} handleClose={onToggleBoxSuppliers}>
                {
                    boxSuppliers &&
                    <Suppliers tableOptions={{ maxBodyHeight: '50vh', minBodyHeight: '50vh', pageSize: 20 }}/>
                }
            </BigDialog>
        </React.Fragment>
    );
};

const makeMapStateToProps = () => {
    const suppliers = lookUpIdValueSelector('suppliers', ['name', 'code', ], item => item.active);
    const compositionByRawMaterial = groupBy('productRawMaterials', 'raw_material_id');
    const mapStateToProps = (state, props) => ({
        compositionByRawMaterial: compositionByRawMaterial(state),
        directRegistersOfShipment: directRegistersByShipment(state),
        rawMaterials: state.rawMaterials.data,
        productsById: state.products.models,
        idAccount: currentUser(state).account_id,
        shipmentsOfRawMaterial: shipmentsByRawMaterial(state),
        suppliers: suppliers(state)
    });
    return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
    alertError: error => dispatch(alertError(error)),
    createRawMatSupplier: data => dispatch(actionsRawMatSuppliers.createPromise(data)),
    removeRawMatSupplier: id => dispatch(actionsRawMatSuppliers.removePromise(id)),
    updateRawMatSupplier: (id, data) => dispatch(actionsRawMatSuppliers.updatePromise(id, data)),
    createSupplierRegister: data => dispatch(actionsSupplierRegister.createPromise(data)),
    removeSupplierRegister: id => dispatch(actionsSupplierRegister.removePromise(id)),
    updateSupplierRegister: (id, data) => dispatch(actionsSupplierRegister.updatePromise(id, data)),
    fetchRawMaterial: id => dispatch(actionsRawMaterials.fetchOne(id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
